import { Release } from "models/release";

export const getReleases = async (): Promise<Release[]> => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND}`);
    const data = (await response.json()) as Release[];
    return data;
};
